import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TCreateRestaurantSelectedPOSType } from '../../../../../createRestaurantState/createRestaurantContext';
import { posSystemTypes } from 'appConstants';

interface IPosSystemSelect {
	setIDPosSystem: (value: TCreateRestaurantSelectedPOSType) => void;
}

const PosSystemSelect: React.FC<IPosSystemSelect> = ({ setIDPosSystem }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectPosSystem') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return posSystemTypes.map((el) => ({ id: el.posSystemID, name: el.posSystemName }));
	}, [posSystemTypes]);

	return (
		<FormSelect
			testId="PosSystemSelect"
			name="IDPosSystem"
			label="posLabel"
			options={mappedOptions}
			onChange={setIDPosSystem}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(PosSystemSelect);
